import React from "react";
import { ProductRes } from "../../../types/productType";
import {useMediaQuery, useTheme } from "@mui/material";
interface SimilarProductProps{
  product: ProductRes
}
export const SimilarProductCard: React.FC<SimilarProductProps> = ({product}) => {
  const theme = useTheme();
  const isLarge = useMediaQuery(theme.breakpoints.up("lg"));
  return (
    
      <div  className="group px-4 relative overflow-hidden w-95 mx-auto">
        <div style={{width:"100%",height:isLarge?"35vh":"45vh"}} className="card ">
          <img
          
            className="card-media object-top"
            style={{borderRadius:"2rem",objectFit:"cover"}}
            src={product.images[0]}
            alt=""
          />
        </div>
        <div className="details pt-3 space-y-1 group-hover-effect">
          <div className="name">
            <h1 className="italic">{product.seller?.sellerName}</h1>
            <p className="font-medium">{product.title}</p>
          </div>
          <div className="price flex items-center gap-3">
            <span className="font-sans text-gray-800">{product.sellingPrice}€</span>
            <span className="thin-line-through text-gray-400">{product.mrpPrice}€</span>
            <span className="text-primary font-semibold ">{product.discountPercentage}%</span>
          </div>
        </div>
      </div>

  );
};
